import { render, staticRenderFns } from "./matrixCheckbox.vue?vue&type=template&id=48f2d1b9&scoped=true&"
import script from "./matrixCheckbox.vue?vue&type=script&lang=ts&"
export * from "./matrixCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./matrixCheckbox.vue?vue&type=style&index=0&id=48f2d1b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f2d1b9",
  null
  
)

export default component.exports